exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wysiwyg-container {\n  max-width: 768px;\n}\n", ""]);

// exports
